<template lang="pug">
modal#creating-webhook-info-modal(
  :noFooter='true'
  :title='$t("modal.creatingWebhookInfo.title")'
  @process='closeModal'
  ref='modal'
)
  .text-center
    p.text-start {{ $t('modal.creatingWebhookInfo.message1') }}
    p.text-start {{ $t('modal.creatingWebhookInfo.message2') }}

    img.mt-4.mb-3(
      alt='developer-delete-warning'
      src='/img/ilustrations/application-warning.svg'
    )

  .modal-footer.p-0.d-flex.justify-content-end
    button#buttonColor.btn.btn-primary(@click='closeModal' type='button')
      | {{ $t('modal.creatingWebhookInfo.okButton') }}
</template>
<script>
import Modal from '@/ui/molecules/Modal.vue';

export default {
  name: 'CreatingWebhookInfoModal',
  components: {
    Modal,
  },
  methods: {
    closeModal() {
      this.$refs.modal.close();
    },
  },
};
</script>
